module.exports = __webpack_public_path__ + "static/media/component8.567f4b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component8.png
// module id = 2412
// module chunks = 0